import { useQuery } from '@tanstack/react-query'

import { useAuth } from '../AuthContext'
import { useSelectedHospital } from '../SelectedHospitalContext'
import { HOSPITAL_OPTIONS_KEY, fetchHospitalOptions } from '../api/hospitals'

/**
 * Hospital selector for amtc_admins, rendered in the shell's MANAGING block.
 * Drives the shared `SelectedHospitalContext` that the Home and Beds pages
 * read. Hidden for hospital_admins — they manage exactly one hospital.
 */
export function HospitalPicker() {
  const { token } = useAuth()
  const { hospitalId, setHospitalId } = useSelectedHospital()

  const { data: options } = useQuery({
    queryKey: HOSPITAL_OPTIONS_KEY,
    queryFn: () => fetchHospitalOptions(token),
    enabled: Boolean(token),
    staleTime: 5 * 60 * 1000, // the closed list of 10 barely changes
  })

  return (
    // No visible "Managing" label of its own: the shell's sidebar renders the
    // MANAGING heading above this (M23-T02), and carrying one here printed the
    // word twice. The accessible name stays on the select.
    <label className="block text-sm">
      <select
        aria-label="Hospital to manage"
        value={hospitalId ?? ''}
        onChange={(e) => setHospitalId(e.target.value || null)}
        className="w-full rounded-[8px] border border-line-2 bg-bg-app px-2 py-1.5 text-sm text-ink-1 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent"
      >
        <option value="">Select a hospital…</option>
        {(options ?? []).map((h) => (
          <option key={h.id} value={h.id}>
            {h.name}
          </option>
        ))}
      </select>
    </label>
  )
}
